import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=2671bdf6&scoped=true&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"
import style0 from "./UsersList.vue?vue&type=style&index=0&id=2671bdf6&lang=scss&scoped=true&"
import style1 from "./UsersList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2671bdf6",
  null
  
)

component.options.__file = "UsersList.vue"
export default component.exports